var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isMiniProgram)?_c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":_vm.leftText,"right-text":_vm.rightText,"left-arrow":"","fixed":_vm.fixed},on:{"click-left":_vm.onClickLeft,"click-right":_vm.onClickRight}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }